// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__d6-v2"};